import { render, staticRenderFns } from "./AnnotationsLogs.vue?vue&type=template&id=0ee8781e&scoped=true&"
import script from "./AnnotationsLogs.vue?vue&type=script&lang=js&"
export * from "./AnnotationsLogs.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsLogs.vue?vue&type=style&index=0&id=0ee8781e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee8781e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VDataTable,VDialog,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})
